// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../../../src/lib/component-base';
// children
import RadioButton from '../../../../../../../../../shared/components/RadioButton/RadioButton';
import MultiSelect from '../../../../../../../../../shared/components/MultiSelect/MultiSelect';
import IconHeader from '../../../../../../../../../shared/components/IconHeader/IconHeader';
// redux
import { handleCheckedSearchChange } from '../../../../../../../redux/actions';
// static assets
import textEditIcon from '../../../../../../../../../static/images/TextEdit-Icon.svg';
// helpers
import { stringToRegexSearch } from '../../../../../../../../../shared/lib/string-helpers';
// constants
import {
  labels,
  fieldMappingByExportType,
  searchCategories,
  modalLabelMapping,
} from '../../../constants';

@componentBase('ExportMultiSelects')
export default class ExportMultiSelects extends Component {
  static propTypes = {
    arrivalCheckedSearch: PropTypes.string,
    checkedSearchInvalid: PropTypes.string,
    departureCheckedSearch: PropTypes.string,
    arrivalAirports: PropTypes.array,
    departureAirports: PropTypes.array,
    arrivalCountries: PropTypes.array,
    departureCountries: PropTypes.array,
    arrivalRegions: PropTypes.array,
    departureRegions: PropTypes.array,
    dispatch: PropTypes.func,
    name: PropTypes.string,
    params: PropTypes.object,
    icon: PropTypes.string,
    title: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
    };
  }

  handleRadioButtonChange = (e) => {
    const { arrivalCheckedSearch } = this.props;
    const field = arrivalCheckedSearch ? 'arrivalCheckedSearch' : 'departureCheckedSearch';
    const result = { [field]: e };
    this.props.dispatch(handleCheckedSearchChange(result));
  }

  get checkedSearch() {
    const {
      arrivalCheckedSearch,
      departureCheckedSearch,
    } = this.props;
    if (arrivalCheckedSearch || departureCheckedSearch) {
      return arrivalCheckedSearch || departureCheckedSearch;
    }
    return '';
  }

  get checkedSearchInvalid() {
    const {
      checkedSearchInvalid,
    } = this.props;
    return checkedSearchInvalid || '';
  }

  renderRadioButton = (category, index) => {
    const { label, value } = category;
    const { name } = this.props;
    const { checkedSearch } = this;
    const isChecked = checkedSearch && (checkedSearch === value);
    return (
      <div className='col-xs-12 col-md-4' key={`${name}-${value}-${index}`}>
        <RadioButton
          title={`${label}`}
          name={name}
          option={value}
          checked={isChecked}
          onChange={e => this.handleRadioButtonChange(e)}
        />
      </div>
    );
  }

  renderFieldLabels = (exportType, filterType, name) => {
    const fields = fieldMappingByExportType[exportType];

    return fields.map((field, i) => {
      const { label, fieldType } = field;
      const specificField = `${name}${fieldType}`;
      const defaultLabel = labels[fieldType];
      const data = this.props[fieldType];
      const key = `${label}${i}`;

      if (!data) {
        return '';
      }

      if (!stringToRegexSearch(filterType, specificField)) {
        return '';
      }

      const finalLabel = `${label} ${this.checkedSearchInvalid}`;
      const {
        params,
        dispatch,
        arrivalAirports,
        departureAirports,
        arrivalCountries,
        departureCountries,
        arrivalRegions,
        departureRegions,
      } = this.props;

      return (
        <MultiSelect
          key={key}
          dispatch={dispatch}
          titleLabel={finalLabel}
          titleLabelClass={this.checkedSearchInvalid ? 'data-export-form-error' : ''}
          modalTitleLabel={defaultLabel}
          modalIcon={textEditIcon}
          options={data}
          params={params}
          modalLabelMapping={modalLabelMapping}
          fieldType={fieldType}
          arrivalAirports={arrivalAirports}
          departureAirports={departureAirports}
          arrivalCountries={arrivalCountries}
          departureCountries={departureCountries}
          arrivalRegions={arrivalRegions}
          departureRegions={departureRegions}
        />
      );
    });
  }

  render() {
    const {
      name,
      params,
    } = this.props;

    const { checkedSearch } = this;

    return (
      <div>
        <div className='multiselect-wrapper'>
          <div className='multiselect-wrapper-inner'>
            <IconHeader
              icon={this.props.icon}
              title={this.props.title}
              iconStyle={{ width: '30px' }}
              titleStyle={{ height: '30px' }}
            />
            <div className='search-radio-buttons row'>
              <p className='search-by-title'>Search By</p>
              {searchCategories.map((c, i) => this.renderRadioButton(c, i))}
            </div>
            <div>{this.renderFieldLabels(params.exportType, checkedSearch, name)}</div>
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/children/CompileDataForm/children/DateAndMultiSelect/children/ExportMultiSelects.js